import { Injectable, computed } from '@angular/core';
import { GroupItemsSelectionHelper } from './group-items-selection-helper.interface';

@Injectable({
  providedIn: 'root',
})
export class NoOpGroupItemsSelectionHelper
  implements GroupItemsSelectionHelper
{
  private static readonly emptyIds = new Set<string>();

  public readonly groupedShiftIds = computed(
    () => NoOpGroupItemsSelectionHelper.emptyIds,
  );

  public readonly groupedStayIds = computed(
    () => NoOpGroupItemsSelectionHelper.emptyIds,
  );

  public selectGroupItems(elementId: string): Promise<void> {
    void elementId;
    return Promise.resolve();
  }

  public updateGroupItemsSelection(elementId: string): Promise<void> {
    void elementId;
    return Promise.resolve();
  }

  public syncGroupItemsFromElementIds(elementIds: string[]): Promise<void> {
    void elementIds;
    return Promise.resolve();
  }

  public clearSelectedItems(): Promise<void> {
    return Promise.resolve();
  }
}
